// extracted by mini-css-extract-plugin
export default {"icon":"QuoteBlock_icon__OHXKn","blockquote":"QuoteBlock_blockquote__7jRQx"};